function QuestionIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z'
        stroke='#24242D'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M8.77821 11.8891C8.77821 12.0954 8.69627 12.2932 8.55041 12.4391C8.40454 12.5849 8.20671 12.6669 8.00043 12.6669C7.79415 12.6669 7.59632 12.5849 7.45046 12.4391C7.3046 12.2932 7.22266 12.0954 7.22266 11.8891C7.22266 11.6828 7.3046 11.485 7.45046 11.3391C7.59632 11.1933 7.79415 11.1113 8.00043 11.1113C8.20671 11.1113 8.40454 11.1933 8.55041 11.3391C8.69627 11.485 8.77821 11.6828 8.77821 11.8891Z'
        fill='#24242D'
      />
      <path
        d='M8.00011 9.55523V8.77745C8.00011 7.99967 10.3334 7.61079 9.94455 5.66634C9.55566 3.7219 6.44455 3.7219 6.05566 5.66634'
        stroke='#24242D'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default QuestionIcon;
